<template>
    <span
      class="inline-flex items-center font-ww-regular font-normal px-2 py-1.5 rounded-full bg-lifeboost-green-dark text-lifeboost-green-dark-green">
     
      <span class="mx-2 text-lg text-white">Verified Buyer</span>
      <!-- <span class="sr-only">{{ component.srText }}</span> -->
    </span>
  </template>
  
  <script setup>

  </script>
  